import { clickstreamLogger } from '~/logging';

type ParseGetParamsResult = { [key: string]: string };

interface IParseGetParams {
  queryString?: string;
  params?: string[];
}

export const parseGetParams = ({
  queryString,
  params,
}: IParseGetParams): ParseGetParamsResult | false => {
  try {
    const finalQueryString = queryString || location?.search;

    const searchParams = new URLSearchParams(finalQueryString);

    if (!params?.length) {
      const allKeyValuesObject: { [key: string]: string } = {};
      searchParams.forEach((value, key) => (allKeyValuesObject[key] = value));

      return allKeyValuesObject;
    } else {
      const selectedValuesObject: { [key: string]: string } = {};
      searchParams.forEach((value, key) => {
        if (params?.includes(key)) {
          selectedValuesObject[key] = value;
        }
      });

      return selectedValuesObject;
    }
  } catch (e) {
    clickstreamLogger.error(e);

    return false;
  }
};
